import { styled } from '@teko/ds-desktop';
import { Modal } from '@teko/ui';
import React, { useState } from 'react';
import { DiscoveryBlock } from 'types';
import { YoutubeFrame } from '../../YoutubeFrame';

interface YoutubeBlockProps {
  block: DiscoveryBlock;
  marginBottom?: number;
}

interface StyledYtbBannerProps {
  backgroundImage?: string;
  backgroundColor?: string;
  marginBottom?: number;
}

const StyledYtbBanner = styled.div<StyledYtbBannerProps>(
  ({
    backgroundColor,
    backgroundImage,
    marginBottom,
  }: StyledYtbBannerProps) => `
    background-image: ${backgroundImage ? `url(${backgroundImage})` : 'unset'};
    background-color: ${backgroundColor ? `${backgroundColor}` : '#c4c4c4'};
    min-height: 700px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: ${marginBottom ? `${marginBottom}px` : 'unset'};
  `,
);

const IFrameWrapper = styled.div`
  position: relative;
  left: 51%;
  height: 279px;
  width: 496px;
`;

const IFramePopupWrapper = styled.div`
  width: 100%;
  height: 540px;
  background-color: black;
`;

export const YoutubeBlock: React.FC<YoutubeBlockProps> = ({
  block,
  ...props
}: YoutubeBlockProps) => {
  const openInPopup = block.openInPopup;
  const [showPopup, setShowPopup] = useState(false);

  const handleClickVideo = () => {
    if (openInPopup) {
      setShowPopup(true);
    }
  };

  const youtubeLink = block.youtubeUrl || block.viewMoreUrl;

  return (
    <>
      {!!youtubeLink && (
        <>
          <StyledYtbBanner
            backgroundImage={block.backgroundImageUrl}
            backgroundColor={block.backgroundColor}
            {...props}
          >
            <IFrameWrapper onClick={handleClickVideo}>
              <YoutubeFrame
                youtubeLink={block.youtubeUrl || block.viewMoreUrl}
                openInPopup={openInPopup}
              />
            </IFrameWrapper>
          </StyledYtbBanner>
          {openInPopup && (
            <Modal
              size="lg"
              show={showPopup}
              onHide={() => setShowPopup(false)}
            >
              <IFramePopupWrapper>
                <YoutubeFrame youtubeLink={youtubeLink} />
              </IFramePopupWrapper>
            </Modal>
          )}
        </>
      )}
    </>
  );
};
